var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "navbar" },
    [
      _vm.showLogo
        ? _c("logo", { attrs: { collapse: _vm.isCollapse } })
        : _vm._e(),
      _c("hamburger", {
        staticClass: "hamburger-container",
        class: { "hamburger-close-slide": _vm.isCollapse },
        attrs: { "is-active": _vm.sidebar.opened },
        on: { toggleClick: _vm.toggleSideBar },
      }),
      _c(
        "div",
        {
          staticClass: "right-menu",
          staticStyle: { display: "flex", "align-items": "center" },
        },
        [
          _vm.$store.getters.isPii
            ? _c("time-zone-select", {
                staticClass: "right-menu-item hover-effect lang-select",
                staticStyle: { height: "60px", "line-height": "60px" },
              })
            : _vm._e(),
          _vm.$store.getters.isPii
            ? _c("div", { staticClass: "line-flex" })
            : _vm._e(),
          _c("DownLoadManage"),
          _c("div", { staticClass: "line-flex" }),
          _vm.$store.getters.isPii
            ? _c("country-select", {
                staticClass: "right-menu-item hover-effect lang-select",
              })
            : _vm._e(),
          _vm.$store.getters.isPii
            ? _c("div", { staticClass: "line-flex" })
            : _vm._e(),
          _c("lang-select", {
            staticClass: "right-menu-item hover-effect lang-select",
          }),
          _c("div", { staticClass: "line-flex" }),
          _vm.$store.getters.isPii
            ? _c("message-manage", {
                staticClass: "right-menu-item hover-effect lang-select",
              })
            : _vm._e(),
          _vm.$store.getters.isPii
            ? _c("div", { staticClass: "line-flex" })
            : _vm._e(),
          _c(
            "div",
            { staticClass: "username" },
            [
              _vm.kycStatusCode && !_vm.$store.getters.isMX
                ? _c(
                    "span",
                    {
                      staticClass: "kyc-status",
                      class: [
                        _vm.getKycStatusClass,
                        { "kyc-clickable": _vm.isKycClickable },
                      ],
                      on: { click: _vm.handleKycClick },
                    },
                    [_vm._v(_vm._s(_vm.getKycStatusLabel))]
                  )
                : _vm._e(),
              _c(
                "el-tooltip",
                {
                  attrs: {
                    disabled: _vm.name.length < 25,
                    placement: "top",
                    effect: "light",
                  },
                },
                [
                  _c("div", { attrs: { slot: "content" }, slot: "content" }, [
                    _vm._v(_vm._s(_vm.name)),
                  ]),
                  _vm.name.length >= 25
                    ? _c("span", { staticClass: "name-content" }, [
                        _c("strong", [_vm._v(_vm._s(_vm.name))]),
                      ])
                    : _c("span", [_c("strong", [_vm._v(_vm._s(_vm.name))])]),
                ]
              ),
            ],
            1
          ),
          _c(
            "el-dropdown",
            {
              staticClass: "avatar-container right-menu-item hover-effect",
              attrs: { trigger: "click" },
            },
            [
              _c("div", { staticClass: "avatar-wrapper" }, [
                _c("img", {
                  staticClass: "user-avatar",
                  attrs: {
                    src: require("@/assets/head_images/head_image.png"),
                  },
                }),
                _c("i", { staticClass: "el-icon-arrow-down icon-arrow-down" }),
              ]),
              _c(
                "el-dropdown-menu",
                {
                  staticClass: "user-dropdown",
                  attrs: { slot: "dropdown" },
                  slot: "dropdown",
                },
                [
                  _c(
                    "router-link",
                    { attrs: { to: "/" } },
                    [
                      _c("el-dropdown-item", [
                        _vm._v(" " + _vm._s(_vm.$t("components.home")) + " "),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "el-dropdown-item",
                    {
                      attrs: { divided: "" },
                      nativeOn: {
                        click: function ($event) {
                          return _vm.gotoAccountSetting($event)
                        },
                      },
                    },
                    [
                      _c("span", { staticStyle: { display: "block" } }, [
                        _vm._v(_vm._s(_vm.$t("menu.account_settings"))),
                      ]),
                    ]
                  ),
                  _c(
                    "el-dropdown-item",
                    {
                      attrs: { divided: "" },
                      nativeOn: {
                        click: function ($event) {
                          return _vm.logout($event)
                        },
                      },
                    },
                    [
                      _c("span", { staticStyle: { display: "block" } }, [
                        _vm._v(" " + _vm._s(_vm.$t("components.login_out"))),
                      ]),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }